import type { ComponentType } from "react";
import type { CharacterView, OpenChoice } from "./api/types";

export interface StepProps {
  step: string;
}

export interface SheetTab {
  id: string;
  label: string;
  component: ComponentType;
  /** Shown only in the given modes; all modes when omitted. */
  modes?: CharacterView["mode"][];
}

/** What a rule system contributes to the user interface. The core shell never imports a system directly. */
export interface SystemUi {
  id: string;
  wizardSteps?: Record<string, ComponentType<StepProps>>;
  sheetTabs: SheetTab[];
  playPanel?: ComponentType;
  /** The most important values of a character at a glance, for the group page; rendered inside the character's context. */
  groupCard?: ComponentType;
  /** Open choices that the module's own step components present, so the wizard does not show them twice. */
  handlesChoice?: (choice: OpenChoice) => boolean;
}

const systems = new Map<string, SystemUi>();

export function registerSystem(ui: SystemUi): void {
  systems.set(ui.id, ui);
}

export function systemUi(id: string): SystemUi | undefined {
  return systems.get(id);
}

/** The sheet tabs of a system that belong to the given mode, in their order. */
export function sheetTabsFor(ui: SystemUi | undefined, mode: CharacterView["mode"]): SheetTab[] {
  return (ui?.sheetTabs ?? []).filter((t) => !t.modes || t.modes.includes(mode));
}
